function Config() {
    this.codicecliente = "rietec";
    this.nome_app = "RMobile";
    this.nome_azienda = "RMobile";
    this.iride_url = "https://www.irideglobalservice.it";
    this.api_url = this.iride_url + "/api/webapps/IWRestRietecApp/";
    this.client_secret = "PNWBYUCQLOETXJFD";
}

export default Config;